import { render, staticRenderFns } from "./RewardGiftList.vue?vue&type=template&id=b6c27e6a&"
import script from "./RewardGiftList.vue?vue&type=script&lang=js&"
export * from "./RewardGiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports